import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _get from "lodash/get"

import DefaultContainer from "shared/components/DefaultContainer"
import Typograph from "../../../../components/Typograph"
import Button from "shared/components/Button/Button"

import styles from "./styles.css"

import { formatDataTraffic } from "../../utils/dataTrafficHelpers"

import SummaryIcon from "../../../../assets/svg/summary.svg"

const SummaryCard = ({ t, cardItems, productSelected, history }) => {
  const serviceId = _get(productSelected, "serviceId", "")
  const summaryData = formatDataTraffic(cardItems)

  const cardContainer = classnames("Grid", styles.cardContainer)

  return (
    <DefaultContainer>
      <div className={styles.containerTitle}>
        <img src={SummaryIcon} alt="Ícone de resumo" />
        <Typograph
          htmlTag="h2"
          size="medium"
          color="charcoal_grey"
          weight="semi_bold"
        >
          Resumo
        </Typograph>
      </div>

      <div className={styles.customContainer}>
        {_map(summaryData, (item, index) => (
          <div key={index} className={styles.box}>
            <Typograph
              htmlTag="h3"
              color="charcoal_grey"
              size="medium"
              weight="semi_bold"
            >
              {item.dataTrafficName}
            </Typograph>
            <div className={cardContainer}>
              <div className={styles.itemsCard}>
                <Typograph
                  htmlTag="h4"
                  color="deep_sea_green"
                  size="small"
                  weight="regular"
                >
                  {t("MSG_0179")}
                </Typograph>

                <Typograph
                  htmlTag="p"
                  color="charcoal_grey"
                  size="extra_small"
                  weight="regular"
                >
                  {item.balanceAvailable}
                </Typograph>
              </div>
              <div className={styles.piped} />

              <div className={styles.itemsCard}>
                <Typograph
                  htmlTag="h4"
                  color="deep_sea_green"
                  size="small"
                  weight="regular"
                >
                  {t("MSG_0181")}
                </Typograph>

                <Typograph
                  htmlTag="p"
                  color="charcoal_grey"
                  size="extra_small"
                  weight="regular"
                >
                  {item.creditLimit}
                </Typograph>
              </div>
            </div>

            <div className={cardContainer}>
              <div className={styles.itemsCard}>
                <Typograph
                  htmlTag="h4"
                  color="deep_sea_green"
                  size="small"
                  weight="regular"
                >
                  {t("MSG_0180")}
                </Typograph>

                <Typograph
                  htmlTag="p"
                  color="charcoal_grey"
                  size="extra_small"
                  weight="regular"
                >
                  {item.expiryDate}
                </Typograph>
              </div>
              <div className={styles.piped} />
              <div className={styles.itemsCard}>
                <Typograph
                  htmlTag="h4"
                  color="deep_sea_green"
                  size="small"
                  weight="regular"
                >
                  {t("MSG_0182")}
                </Typograph>

                <Typograph
                  htmlTag="p"
                  color="charcoal_grey"
                  size="extra_small"
                  weight="regular"
                >
                  {item.effectiveDate}
                </Typograph>
              </div>
            </div>

            <Button
              width="medium"
              onClick={() => history.push(`/data-traffic/${serviceId}`)}
            >
              Detalhamento
            </Button>
          </div>
        ))}
      </div>
    </DefaultContainer>
  )
}

SummaryCard.propTypes = {
  t: PropTypes.func,
  cardItems: PropTypes.array,
  productSelected: PropTypes.object,
  history: PropTypes.object
}

export default SummaryCard



// WEBPACK FOOTER //
// ./src/scenes/DataQuota/components/SummaryCard/index.js